import { forwardRef, type FC } from 'react';

import iconPath from '@wwe-portal/ui/assets/icons/icomoon.svg';
import { cn } from '@wwe-portal/ui/lib/lib';

import type { IconProps } from '../type';

export interface IcoMoonIconProps extends IconProps {
  iconName: string;
}
export const IcoMoonIcon = forwardRef<SVGSVGElement, IcoMoonIconProps>(
  ({ iconName, ...props }, ref) => {
    return (
      <svg {...props} ref={ref} aria-label={iconName}>
        <use fill="currentColor" href={`${iconPath}#${iconName}`} />
      </svg>
    );
  }
);
IcoMoonIcon.displayName = 'IcoMoonIcon';

export interface IcoMoonSpanProps extends IcoMoonIconProps {
  iconClassName?: string;
}
export const IcoMoonSpan: FC<IcoMoonSpanProps> = ({
  className,
  iconClassName,
  ...props
}) => {
  return (
    <span className={cn('inline', className)}>
      <IcoMoonIcon {...props} className={cn('size-[1em]', iconClassName)} />
    </span>
  );
};
